import React from 'react'
import classnames from 'classnames'

import { followStoreLink$ } from '../navigation'

import style from './FundsCheckCard.module.css'
import { formatDate } from '@apiEnabler/ob-common/lib/date-utils'

export default function FundsCheckCard({ tpp, consent, index }) {
  return (
    <button
      className={classnames(style.card, `js-funds-check-card-${index}`)}
      onClick={() =>
        followStoreLink$.next(
          `/funds-checks/tpps/${tpp.get('clientId')}/funds-checks/${consent.get(
            'id'
          )}`
        )
      }
    >
      <div className={classnames(style.content, 'js-content')}>
        <span
          className={classnames(
            style.consentLabel,
            'js-consent-permission-label'
          )}
        >
          {consent.get('status') === 'ACCEPTED'
            ? 'Created on '
            : 'Permission provided '}
          {formatDate(consent.get('createdAt'), 'DD MMM YYYY')}
        </span>
      </div>
    </button>
  )
}
